import type { FC } from 'react';
import { Alert } from '@george-labs.com/design-system';
import type { ALERT_VARIANT } from '@george-labs.com/design-system/types/components/Alert';

interface Props {
    variant: ALERT_VARIANT;
    alert?: string;
}

export const PhoneNumberAlert: FC<Props> = ({ variant, alert }) => {
    if (!alert) {
        return null;
    }

    return (
        <Alert size={Alert.SIZE.SMALL} variant={variant}>
            {alert}
        </Alert>
    );
};
